// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import jsQR from "jsqr";
import QRCode from "qrcode";
import "./report_session_form_sync.js";
import "./pwa_install.js";
import "./clip_recorder.js";
import "./clip_upload.js";

window.jsQR = jsQR;

const renderQrCodes = () => {
  document.querySelectorAll("[data-qr-value]").forEach(async (element) => {
    const value = element.getAttribute("data-qr-value");
    if (!value) return;
    try {
      const svg = await QRCode.toString(value, { type: "svg", margin: 1, width: 220 });
      element.innerHTML = svg;
    } catch (_error) {
      element.textContent = "Unable to render QR code.";
    }
  });
};

const wireSupportEmailReveal = () => {
  const btn = document.getElementById("support-email-reveal");
  const span = document.getElementById("support-email-obfuscated");
  if (!btn || !span || btn.dataset.bound == "1") return;

  btn.dataset.bound = "1";
  btn.addEventListener("click", () => {
    const user = btn.dataset.emailUser;
    const host = btn.dataset.emailHost;
    if (!user || !host) return;

    const email = `${user}@${host}`;
    const a = document.createElement("a");
    a.href = `mailto:${email}`;
    a.textContent = email;
    a.style.fontWeight = "600";
    a.style.color = "#334155";
    span.replaceWith(a);
    btn.remove();
  });
};

const wireCopyInviteButtons = () => {
  if (document.documentElement.dataset.copyInviteWired === "1") return;
  document.documentElement.dataset.copyInviteWired = "1";

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".copy-invite-btn");
    if (!btn) return;
    const id = btn.getAttribute("data-invite-target");
    const ta = id && document.getElementById(id);
    if (!ta) return;
    const text = ta.value;
    const done = () => {
      const orig = btn.getAttribute("data-label-backup") || btn.textContent;
      if (!btn.getAttribute("data-label-backup")) btn.setAttribute("data-label-backup", orig);
      btn.textContent = "Copied";
      setTimeout(() => {
        btn.textContent = btn.getAttribute("data-label-backup");
      }, 2000);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(done).catch(() => {
        ta.select();
        try {
          document.execCommand("copy");
        } catch (_e) {
          /* ignore */
        }
        done();
      });
    } else {
      ta.select();
      ta.setSelectionRange(0, 99999);
      try {
        document.execCommand("copy");
      } catch (_e) {
        /* ignore */
      }
      done();
    }
  });
};

const wireInactiveLeaderboardToggle = () => {
  const table = document.querySelector("table.dashboard-table--rankings");
  const toggleBtn = document.querySelector("button.leaderboard-inactive-toggle-btn[data-inactive-leaderboard-toggle]");
  if (!table || !toggleBtn) return;
  if (toggleBtn.dataset.bound === "1") return;

  const inactiveRows = table.querySelectorAll("tr.leaderboard-row--inactive");
  if (!inactiveRows || inactiveRows.length === 0) return;

  let collapsed = true;
  const update = () => {
    inactiveRows.forEach((row) => {
      row.style.display = collapsed ? "none" : "table-row";
    });
    toggleBtn.textContent = collapsed
      ? `Show inactive participants (${inactiveRows.length})`
      : `Hide inactive participants (${inactiveRows.length})`;
  };

  toggleBtn.dataset.bound = "1";
  toggleBtn.addEventListener("click", () => {
    collapsed = !collapsed;
    update();
  });

  update();
};


document.addEventListener("DOMContentLoaded", renderQrCodes);
document.addEventListener("turbo:load", renderQrCodes);
document.addEventListener("DOMContentLoaded", wireSupportEmailReveal);
document.addEventListener("turbo:load", wireSupportEmailReveal);
document.addEventListener("DOMContentLoaded", wireInactiveLeaderboardToggle);
document.addEventListener("turbo:load", wireInactiveLeaderboardToggle);
document.addEventListener("DOMContentLoaded", wireCopyInviteButtons);
document.addEventListener("turbo:load", wireCopyInviteButtons);
document.addEventListener("turbo:before-stream-render", () => {
  setTimeout(renderQrCodes, 0);
});
